import { Power, Permissions, Group, UserToUserTransmission } from '@icon-park/vue-next'
import { App } from 'vue'

export const extendIcon = [
  Power,
  Permissions,
  Group,
  UserToUserTransmission
]

// 图标列表：https://iconpark.oceanengine.com/official
export default (app: App): void => {
  extendIcon.forEach((com) => {
    app.component(com.name, com)
  })
}
